import React from 'react';

import moment from 'moment';
/*import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';*/

import { useActions, useDialog, useTabs } from '../../../common/minifield';
import { Spinner } from '../../../common/components/spinner';

import { useAccountCache } from '../../account/account-cache';
import { useDataCache } from '../data-cache';

import { GeneralDataProperties } from '../data-viewer';

const EventEditor = ({ data, onChange }) => {
	const dialog = useDialog();
	
	React.useEffect(() => {
		dialog({
			options: {
				size: 'xl'
			}, 
			buttons: [{
				caption: 'Cancel',
				callback: () => onChange()
			}, {
				caption: 'Close',
				color: 'dark',
				callback: (modal) => modal.hide()
			}]
		});
	}, [dialog, onChange]);
	
	return <span>Coming soon...</span>
}

const EventViewer = ({ data, onChange }) => {
	const dialog = useDialog();
	const tabs = useTabs();
	const [content, setContent] = React.useState();

	React.useEffect(() => {
		if (data) {
			tabs.define('Participants', () => <ParticipantList id={ data.id } namespace={ data.namespace } />);
			tabs.define('General', () => <GeneralDataProperties data={ data } />);
			setContent(tabs.render());
		}	
	}, [data, tabs]);
	
	React.useEffect(() => {
		dialog({
			options: {
				size: 'xl'
			}, 
			buttons: [/*{
				caption: 'Edit',
				callback: () => onChange()
			}, */{
				caption: 'Close',
				color: 'dark',
				callback: (modal) => modal.hide()
			}]
		});
	}, [dialog, onChange]);

	return (
		<div>
			{ content }
		</div>
	);
}

const Event = ({ data }) => {
	const [edited, setEdited] = React.useState();
	if (edited) {
		return <EventEditor data={ data } onChange={ () => setEdited(false) } />
	} else {
		return <EventViewer data={ data } onChange={ () => setEdited(true) } />
	}
}
export { Event }

const ParticipantListItem = ({ eventId, booking }) => {
	const action = useActions();
	
	const doClick = React.useCallback(() => {
		action({ action: 'data-view', payload: { 
			namespace: booking.namespace, 
			type: booking.type, 
			id: booking.id,
			buttons: [{
				caption: 'Back',
				callback: () => action({ action: 'data-view', payload: {
					namespace: booking.namespace,
					type: 'event',
					id: eventId 
				}})
			}, {
				caption: 'Close',
				color: 'dark',
				callback: (modal) => modal.hide()
			}]
		}});
	}, [action, booking, eventId]);
	
	return (
		<tr key={ booking.id } className={ 'clickable table-' + booking.properties.bs_status } onClick={ doClick }>
			<td>{ booking.properties.index }</td>
			<td>{ booking.properties.username }</td>
			<td>{ booking.properties.status }</td>
			<td className="d-none d-md-table-cell">{ booking.properties.creationDate }</td>
			<td>{ booking.properties.modificationDate }</td>
		</tr>
	);
};

const ParticipantList = ({ id, namespace }) => {
	const accounts = useAccountCache({ namespace: namespace });
	const bookings = useDataCache({ namespace: namespace, type: 'booking' });
	const [items, setItems] = React.useState();
	
	React.useEffect(() => {
		if (!accounts || !bookings) {
			return;
		}
		
		let index = 1;
		const data = bookings.filter(x => x.properties.target.includes(id)).map((booking) => {
			booking.properties.creationDate = moment.utc(booking.creationDate).format('dddd, DD/MM/yyyy HH:mm');
			booking.properties.modificationDate = moment.utc(booking.modificationDate).format('dddd, DD/MM/yyyy HH:mm');
			const account = accounts.find(x => x.badge === booking.badge);
			if (account) { 
				booking.properties.username = account.name;
			}
			switch (booking.properties?.status) {
				case 'COMPLETED':
					booking.properties.bs_status = 'success';
					booking.properties.index = index++;
					break;
				case 'CANCELLED':
					booking.properties.bs_status = 'warning';
					break;
				case 'PENDING':
					booking.properties.bs_status = 'info';
					break;
				default:
					booking.properties.bs_status = 'danger';
					break;
			}
			return booking;
		});
		setItems(data);
	}, [id, bookings, accounts]);
	
	if (!items) {
		return <Spinner />;
	}
	
	return (
		<div className="pt-3">
			<table className="table table-striped table-hover m-0">
				<tbody>
				{ items.map((booking) => <ParticipantListItem booking={ booking } eventId={ id } />) }
				</tbody>
			</table>
		</div>
	);
};